import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { formatPriceForDisplay } from '../../../../util/format-money';
import TagIconOutline from '../../../../components/icons/TagIconOutline';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  valueText: PropTypes.string,
  struckValue: PropTypes.number,
  discount: PropTypes.bool,
};

const PriceBreakdownRow = ({
  label,
  value,
  currencySymbol,
  valueText,
  struckValue,
  discount,
}) => {
  const classes = classNames({
    'price-breakdown-row': true,
    'is-discount': !!discount,
  });

  return (
    <div className={classes} key={label}>
      <span className="price-breakdown-label">
        {discount && (
          <TagIconOutline
            className="price-breakdown-label-icon"
            color="currentColor"
          />
        )}
        {label}
      </span>
      <span className="price-breakdown-value">
        {struckValue > 0 && (
          <del className="price-breakdown-value-struck">
            {currencySymbol}
            {formatPriceForDisplay(struckValue, false)}
          </del>
        )}
        {valueText ?? (
          <>
            {value < 0 && '-'}
            {currencySymbol}
            {formatPriceForDisplay(Math.abs(value), false)}
          </>
        )}
      </span>
    </div>
  );
};

PriceBreakdownRow.propTypes = propTypes;

export default PriceBreakdownRow;
